import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type CheckInProps = {
  index: number
}

export const CheckIn = ({ index }: CheckInProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.checkIn`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Checks In" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
